import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//amplify
import Amplify from '@aws-amplify/core';
// in this way you are only importing Auth and configuring it.
Amplify.configure({
    Auth: {
        //storage: sessionStorage,
        mandatorySignId: false,
        region: environment.region,
        userPoolId: environment.cognitoPoolId,
        userPoolWebClientId: environment.cognitoClientId,
        identityPoolId: environment.identityPoolId
    },
    API: {
        endpoints: [
            {
                name: "ironhorsedrilling",
                endpoint: "https://74qqjb8mri.execute-api.us-west-2.amazonaws.com/default/v1/",
                region: 'us-west-2'
            }
        ]
    },
    Storage: {
        AWSS3: {
            bucket: environment.bucketName,
            region: environment.region,
            identityPoolId: environment.identityPoolId
        }
        // customPrefix: {
        //   public: '',
        //   protected: '',
        //   private: ''
        // }
    }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
